import useSetYears from "./date/useSetYears";

export const DatesInitializer = () => {
	useSetYears();

	return null;
};
